/**
 * Garsonun üst çubuğundaki selam (20 Eki 2026): "Günaydın, Enes". "Garson"
 * ibaresi çekmecede zaten yazıyor; burada saate göre selam ve ilk ad.
 */
export function greeting(name: string, hour: number = new Date().getHours()): string {
  const first = name.trim().split(/\s+/)[0] ?? ''
  const hello =
    hour >= 5 && hour < 11 ? 'Günaydın' : hour >= 11 && hour < 17 ? 'Selam' : hour >= 17 ? 'İyi akşamlar' : 'İyi geceler'
  return first ? `${hello}, ${first}` : hello
}
